export default {"src":"/_next/static/media/protection-icon.14884847.svg","height":33,"width":37,"blurWidth":0,"blurHeight":0};